module.exports = __webpack_public_path__ + "img/public/siteImages/verifyTick.svg?edcc5791";